import { pluginApi } from 'services/api';

interface Item {
  label: string;
  value: string;
}

interface FiltersOptions {
  directory?: Item[] | [];
  region?: Item[];
  channel?: Item[];
  uf?: Item[];
}

export default async function getFilters(
  product: string,
  filters: FiltersOptions,
): Promise<Item[]> {
  const params = {
    product,
    directory: filters.directory?.[0]?.value || '',
    region: filters.region?.[0]?.value || '',
    channel: filters.channel?.[0]?.value || '',
    uf: filters.uf?.[0]?.value || '',
  };

  const {
    data,
  } = await pluginApi.get('participants/participant/getProctsByFilters', {
    params,
  });

  return data ?? [];
}
